import Vue from "vue";
import VueRouter from "vue-router";

import internetHospital from "@/components/serve/internet-hospital/index.vue";
import reserve from "@/components/serve/reserve.vue";
import remoteMedical from "@/components/serve/remote-medical.vue";
import guild from "@/components/serve/guild.vue";
import payCheck from "@/components/serve/pay-check.vue";
import health from "@/components/serve/health.vue";

import Smart from "@/components/smart/smart/index.vue";
import digitalManagement from "@/components/smart/digital-management.vue";
import itService from "@/components/smart/it-service/index.vue";
import dataManagement from "@/components/smart/data-management/index.vue";

import Medical from "@/components/medical/medical.vue";
import drgPlatform from "@/components/medical/drg-platform.vue";
import medicalControl from "@/components/medical/medical-control.vue";
import apgManagement from "@/components/medical/apg-management/index.vue";
import reasonableTreatment from "@/components/medical/reasonable-treatment/index.vue";

import News from "@/components/news/index.vue";
import NewsDetail from "@/components/news/news-detail.vue";

import Operate from "@/components/operation/operate/index.vue";

import Home from "@/components/home/index.vue";
import Free from "@/components/other/free.vue";
import About from "@/components/other/About.vue";
import Join from "@/components/other/Join.vue";
import Training from "@/components/other/Training.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/about",
    name: "about",
    component: About,
  },
  {
    path: "/free",
    name: "free",
    component: Free,
  },
  {
    path: "/join",
    name: "join",
    component: Join,
  },
  {
    path: "/training",
    name: "training",
    component: Training,
  },
  {
    path: "/smart",
    name: "smart",
    component: Smart,
  },
  {
    path: "/digital-management",
    name: "digital-management",
    component: digitalManagement,
  },
  {
    path: "/it-service",
    name: "it-service",
    component: itService,
  },
  {
    path: "/data-management",
    name: "data-management",
    component: dataManagement,
  },
  {
    path: "/medical",
    name: "medical",
    component: Medical,
  },
  {
    path: "/drg-platform",
    name: "drg-platform",
    component: drgPlatform,
  },
  {
    path: "/medical-control",
    name: "medical-control",
    component: medicalControl,
  },
  {
    path: "/internet-hospital",
    name: "internet-hospital",
    component: internetHospital,
  },
  {
    path: "/apg-management",
    name: "apg-management",
    component: apgManagement,
  },
  {
    path: "/reasonable-treatment",
    name: "reasonable-treatment",
    component: reasonableTreatment,
  },
  {
    path: "/news",
    name: "news",
    component: News,
  },
  {
    path: "/news-detail",
    name: "news-detail",
    component: NewsDetail,
  },
  {
    path: "/reserve",
    name: "reserve",
    component: reserve,
  },
  {
    path: "/remote-medical",
    name: "remote-medical",
    component: remoteMedical,
  },
  {
    path: "/guild",
    name: "guild",
    component: guild,
  },
  {
    path: "/pay-check",
    name: "pay-check",
    component: payCheck,
  },
  {
    path: "/health",
    name: "health",
    component: health,
  },
  {
    path: '/operate',
    name: 'opearte',
    component: Operate,
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
